import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { db } from "../db/firestore";
import { stringYMDHMS3 } from '../Utility/dateTime';
import { normalSort } from '../Utility/sort';
import { formatTime } from '../Utility/function';

const initialState = {
    requisitions:[], // 
    modal_Requisition:false,
    billDates:[],
    displayRequisition:[],
    startDate:new Date(),
    endDate:new Date(),
}

export const fetchRequisition = createAsyncThunk(
    'requisition/fetchRequisition',
    async ({ shopId, billDate, selectedDate }) => {
      let data = [];
  
      // Split billDate into chunks of 10 elements each
      const chunkSize = 10;
      const billDateChunks = [];
      for (let i = 0; i < billDate.length; i += chunkSize) {
        billDateChunks.push(billDate.slice(i, i + chunkSize));
      }
  
      // Use Promise.all to make multiple queries
      const promises = billDateChunks.map(async (chunk) => {
        const query = db.collection('requisition')
          .where("shopId", "==", shopId)
          .where('billDate', 'in', chunk);
  
        try {
          const qsnapshot = await query.get();
          if (qsnapshot.docs.length > 0) {
            qsnapshot.forEach((doc) => {
              const { timestamp,  ...rest } = doc.data()
              data.push({ 
                ...rest, 
                timestamp: formatTime(timestamp),
                id:doc.id, 
  
              });
            });
          } else {
            console.log('No items found for chunk:', chunk);
          }
        } catch (err) {
          console.error('Error:', err);
        }
      });
  
      // Wait for all queries to complete
      await Promise.all(promises);
      return { data, billDate, selectedDate };
    }
  );



export const requisitionSlice = createSlice({
  name: 'requisition',
  initialState,
  reducers: {
    clearRequisition: state => {
      state.startDate = new Date();
      state.endDate = new Date();
      state.requisitions = [];
      state.displayRequisition = [];
      state.billDates = [];
    },
    updateNormalRequisition: (state, action) => {
      const { importId, newProduct, totalQty, totalCost } = action.payload;
      let item = state.displayRequisition.find(a=>a.id===importId)
      item.product = newProduct
      item.totalQty = totalQty
      item.totalCost = totalCost
    }, 
    updateRequisitions: (state, action) => {
        const { selectedDate } = action.payload
        state.displayRequisition = normalSort('timestamp',state.requisitions.filter(a=>[selectedDate].includes(a.billDate)))
    }, 
    updateStartDate: (state, action) => {
      state.startDate = action.payload
    },
    updateEndDate: (state, action) => {
      state.endDate = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchRequisition.pending, state => {
      state.modal_Requisition = true
    })
    builder.addCase(fetchRequisition.fulfilled, (state, action) => {
      const { data, billDate, selectedDate } = action.payload;
      const today = stringYMDHMS3(new Date())
        let duplicate = billDate.some(a=>a===today)
        if(duplicate){
          state.requisitions = [...state.requisitions.filter(a=>a.billDate!==today),...data]
        } else {
          state.requisitions.push(...data)
        }
        state.billDates.push(...billDate.filter(a=>a!==today))
        state.displayRequisition = normalSort('timestamp',state.requisitions.filter(a=>selectedDate.includes(a.billDate)))
        state.modal_Requisition = false
    })
    builder.addCase(fetchRequisition.rejected, state => {
        state.modal_Requisition = false
    })
  }
})

export const { updateRequisitions, updateStartDate, updateEndDate, updateNormalRequisition, clearRequisition } = requisitionSlice.actions

export default requisitionSlice.reducer